import { createContext } from 'react';
import { SubmenuContext as SubmenuContextType } from '@gs-ux-uitoolkit-common/menu';

export const SubmenuContext = createContext<SubmenuContextType>({
    isSubmenu: false,
    submenuType: 'flyout',
});
